import type {
  DecentralizedCasinoGame,
  NewCasinoGame,
  NewCasinoGameBackend
} from 'interfaces/new-casino';

export const gameMapper = (
  game: NewCasinoGameBackend | NewCasinoGame
): NewCasinoGame => ({
  background: game.background,
  blocked_countries: game.blocked_countries,
  blocked_currencies: game.blocked_currencies,
  categories: game.categories,
  cats: game.cats,
  description: game.description,
  extearnal_game_id: game.extearnal_game_id,
  game_options: game.game_options,
  has_age_restriction: game.has_age_restriction,
  icon_1: game.icon_1,
  icon_2: game.icon_2,
  icon_3: game.icon_3,
  id: game.id,
  name: game.name,
  provider: game.provider,
  provider_title: game.provider_title,
  types: game.types,
  badge: game.badge,
  bet_limits: game.bet_limits
});

export const CASINO_GAME_TEMPLATE: NewCasinoGameBackend = {
  active: '',
  backgrounds: [],
  blocked_countries: [],
  blocked_currencies: [],
  categories: [],
  cats: [],
  description: null,
  extearnal_game_id: '',
  feats: [],
  features: [],
  front_game_id: '',
  game_options: null,
  game_skin_id: '',
  has_age_restriction: 0,
  icon_1: '',
  icon_2: '',
  icon_3: '',
  icons: [],
  id: '',
  name: '',
  provider: '',
  provider_badge: null,
  provider_title: '',
  ratio: '',
  rtp: null,
  server_game_id: '',
  show_as_provider: '',
  status: '',
  themes: [],
  thms: [],
  title: null,
  bet_limits: {},
  types: {
    realMode: 0
  }
};

export const decentralizedGameCategoriesMapper = (
  category: DecentralizedCasinoGame['categories'][0]
): NewCasinoGameBackend['cats'][0] => ({
  id: category.toString(),
  title: '',
  type: ''
});
